import { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
// import PropTypes from "prop-types";
// import cx from "classnames";
import SortableList, { SortableItem } from "react-easy-sort";
import arrayMove from "array-move";
import { ReactTable } from "components/Table";
import { ModalChangeText, ModalTemplate, ModalAddImages, ModalEditDescriptions, ModalEditInformations, ModalExportFileTemplate } from "../modal";
import { countString, formatterCreateAt, scaleNumber } from "components/Function";
import { createProductsByTemplate } from "actions/productActions";
import { changeTitleByAI } from "actions/aiActions";
import { CSVLink } from "react-csv";
import ReactImageMagnify from 'react-image-magnify';
import Loading from "components/Loading";
import XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import { saveAs } from "file-saver";
import { evaluate } from "mathjs";
import { getCategories, getRecommendCategories } from "actions/categoryAction";
import { TreeSelect } from "antd";
import SelectBox from "components/elements/selectBox";
import paginationFactory from "react-bootstrap-table2-paginator";

function Main({ createProductsByTemplate, user, countString, formatterCreateAt, scaleNumber, changeTitleByAI, ai, getCategories, getRecommendCategories }) {
    const [isLoadingExport, setIsLoadingExport] = useState(false);
    const [isLoadingImport, setIsLoadingImport] = useState(false);
    const [isLoadingRecommend, setIsLoadingRecommend] = useState(false);
    const [isCategoryInviteOnly, setIsCategoryInviteOnly] = useState({});
    const [forceRender, setForceRender] = useState(false);
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const { t } = useTranslation();
    const [list, setList] = useState(localStorage.getItem("extension_drop_list_other") ? JSON.parse(localStorage.getItem("extension_drop_list_other")) : []);
    const [products_selected, setProductsSelected] = useState([]);
    const [products_selected_export, setProductsSelectedExport] = useState([]);
    const [initiateDownload, setInitiateDownload] = useState(false);
    const [categoryVersion, setCategoryVersion] = useState("v2");
    const [categories, setCategories] = useState([]);
    const btnRef = useRef(null);
    var { _id, parentId, expired_at } = user.user;
    var { isLoading } = ai;

    useEffect(() => {
        localStorage.setItem("extension_drop_list_other", JSON.stringify(list));

        // var extension_settings = JSON.parse(localStorage.getItem("extension_settings"));
        // if (typeof extension_settings?.["general"]?.crawl_tab === "undefined" || extension_settings?.["general"]?.crawl_tab === "0") {
        //     // var list_tmp = JSON.parse(localStorage.getItem("extension_listother"));
        //     // if (list_tmp) {
        //     //     localStorage.setItem("extension_listother", JSON.stringify(list_tmp?.filter((v2, i2) => list?.some((v1, i1) => v1.product_id === v2.product_id))));
        //     // }
        // }
    }, [list]);
    
    useEffect(() => {
        const handleLocalStorageFromExtension = () => {
            setList(JSON.parse(localStorage.getItem("extension_drop_list_other")));
        };

        window.addEventListener("updateLocalStorageFromExtension", handleLocalStorageFromExtension);
    
        return () => {
            window.removeEventListener("updateLocalStorageFromExtension", handleLocalStorageFromExtension);
        };
    }, []);

    useEffect(() => {
        setInitiateDownload(false);
        if (initiateDownload) {
            btnRef.current?.click();
        }
    }, [initiateDownload]);

    useEffect(() => {
        getCategories(() => {}, categoryVersion).then((data) =>
            setCategories((data || []).map((c) => ({ value: c.id, label: c.local_name, children: c.children })))
        );
    }, [categoryVersion, getCategories]);

    const onClickExport = () => {
        setIsLoadingExport(true);
        var products_selected_export = [];
        products_selected_export = list?.filter((v, i) => products_selected?.includes(v.product_id))?.map((v, i) => {
            return { product_id: "'" + v.product_id, title: v.title, images: v.images.join() }
        })
        setProductsSelectedExport(products_selected_export);
        setInitiateDownload(true);
        setIsLoadingExport(false);
    }

    const getExcelColumnName = (colIndex) => {
        let columnName = "";
        while (colIndex >= 0) {
            columnName = String.fromCharCode((colIndex % 26) + 65) + columnName;
            colIndex = Math.floor(colIndex / 26) - 1;
        }
        return columnName;
    }
    
    const onClickExportFileTemplate = async ({ template }) => {
        setIsLoadingExport(true);
        const response = await fetch(`/files/${template}.xlsx`);
        const arrayBuffer = await response.arrayBuffer();
        
        const workbook = await XlsxPopulate.fromDataAsync(arrayBuffer);
        
        const sheet = workbook.sheet(0);
        const usedRange = sheet.usedRange();
        const columnCount = usedRange.endCell().columnNumber();
        
        const data = list?.filter((v, i) => products_selected?.includes(v.product_id)).flatMap((v, i) => 
            v?.variants_split.map(variant => {
                var { price, image } = variant;

                const validKeys = Object.keys(variant).filter(key => key !== "price" && key !== "image");

                const values = validKeys.map(key => variant[key]).slice(0, 2);
                while (values.length < 2) values.push("");

                var data_arr = ["", "No brand", v?.title || "", v?.descriptions || "", v?.images?.[0] || "", v?.images?.[1] || "", v?.images?.[2] || "", v?.images?.[3] || "", v?.images?.[4] || "", v?.images?.[5] || "", v?.images?.[6] || "", v?.images?.[7] || "", v?.images?.[8] || "", v?.images?.[9] || "", "", ...values, image || "", +v?.weight?.value || "", +v?.dimensions?.length || "", +v?.dimensions?.width || "", +v?.dimensions?.height || "", "", +price || "", 50];
                data_arr.push(...Array(columnCount-1-25).fill(""), "Active(1)");
        
                return data_arr;
            })
        );

        const startRow = 7;
        const numRows = data.length;
        const numCols = Math.max(...data.map(row => row.length));

        const endRow = startRow + numRows - 1;
        const endCol = getExcelColumnName(numCols - 1);

        sheet.range(`A${startRow}:${endCol}${endRow}`).value(data);

        const newExcelBuffer = await workbook.outputAsync();
        const blob = new Blob([newExcelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, "other_" + formatterCreateAt((new Date()).getTime(), "dmy") + ".xlsx");
        setIsLoadingExport(false);
    }

    const onClickGetRecommendCategories = (row = [], formatExtraData) => {
        setIsLoadingRecommend(true);
        getRecommendCategories(
            () => {},
            formatExtraData?.categoryVersion || "v2",
            row?.title,
            row?.images?.[0] || ""
        ).then((data) => {
            // setCategories((data || []).map((c) => ({ value: c.id, label: c.local_name, children: c.children })));
            if (data?.[data?.length - 1]?.id) {
                setList((prev) => {
                    prev = prev.map((item) => {
                        if (item.product_id === row.product_id) {
                            return { ...item, category: data?.[data?.length - 1]?.id };
                        }
                        return item;
                    });
                    return prev;
                });
                setIsCategoryInviteOnly((prev) => {
                    prev = {
                        ...prev,
                        [row.product_id]: data?.[data?.length - 1]?.permission_statuses.includes("INVITE_ONLY") ? true : false
                    };
                    return prev;
                });
            }
            setIsLoadingRecommend(false);
        });
    };

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            editable: false,
            formatter: (cell, row, rowIndex) => (page - 1) * sizePerPage + rowIndex + 1,
        },
        {
            dataField: "shop_name",
            text: t("Shop Name"),
            sort: true,
            editable: false,
        },
        {
            dataField: "product_id",
            text: t("Product ID"),
            sort: true,
            editable: false,
            formatter: (cell, row, rowIndex) => <Fragment><Link to={row?.product_link || "#"} target={row?.product_link ? "_blank" : "_self"}>{cell}</Link></Fragment>,
        },
        {
            dataField: "title",
            text: t("Title"),
            sort: true,
            classes: "al-cursor-pointer",
            headerStyle: { minWidth: "500px" },
            formatter: (cell, row, rowIndex) => (
                <Fragment>
                    <div>
                        <span className={cell?.length < 140 && cell?.length > 40 ? "text-success" : "text-danger"}>
                            Total Title: {cell?.length} <span className="text-info">{countString(cell)}</span>
                        </span>
                    </div>
                    {cell} <i className="fa fa-pencil"></i>
                </Fragment>
            ),
        },
        {
            dataField: "images",
            text: t("Images"),
            sort: true,
            editable: false,
            style: {
                minWidth: "500px",
                maxWidth: "500px",
            },
            formatter: (cell, row, rowIndex) => (
                <Fragment>
                {/* <div style={{ height: "auto", maxHeight: "300px", overflow: "auto" }}> */}
                    <div>
                        <span className="text-success">
                            Total Images: {cell?.length}
                        </span>
                    </div>
                    <SortableList
                        onSortEnd={(oldIndex, newIndex) => onSortEnd(oldIndex, newIndex, rowIndex)}
                        className="al-thumbsContainer"
                        draggedItemClassName="dragged"
                    >
                        {cell?.map((v, i) => {
                            return (
                                <SortableItem key={i}>
                                    <div className="al-thumb">
                                        <div className="al-thumbInner position-relative">
                                            <button
                                                onClick={() => removeImageProduct(row.product_id, i)}
                                                type="button"
                                                className="btn-delete-image"
                                                style={{ zIndex: 9 }}
                                            >
                                                <i className="fa fa-trash"></i>
                                            </button>
                                            <ReactImageMagnify {...{ imageStyle: { objectFit: "cover" }, imageClassName: "al-product-img al-cursor-move w-100 h-100", smallImage: { alt: "", src: v || require("components/assets/media/misc/image.png"), width: 90, height: 90 }, largeImage: { src: v || require("components/assets/media/misc/image.png"), width: 300, height: 300 }, enlargedImageContainerDimensions: { width: '300%', height: '300%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />
                                        </div>
                                    </div>
                                </SortableItem>
                            );
                        })}
                    </SortableList>
                {/* </div> */}
                </Fragment>
            ),
        },
        {
            dataField: "variants_split",
            text: t("Variants"),
            sort: true,
            editable: false,
            style: {
                minWidth: "500px",
                maxWidth: "500px",
            },
            formatter: (cell, row, rowIndex) => (
                // <div style={{ height: "auto", maxHeight: "300px", overflow: "auto" }}>
                //     {
                //         cell.map((v, i) => (
                //             <Fragment key={i}>
                //                 <h6>{v.key}:</h6>{
                //                     v.value.map((v_value, i_value) => (
                //                         <Link to="#" className="btn btn-bg-light btn-active-icon-gray-900 btn-active-text-gray-900 me-2 mb-2" key={i_value}>
                //                             {
                //                                 v.images.length > 0 ?
                //                                     <div className="symbol symbol-50px me-2">
                //                                         <img src={v.images[i_value]} alt="" className="h-75" />
                //                                     </div>
                //                                 : ""
                //                             }
                //                             {v_value}
                //                         </Link>
                //                     ))
                //                 }
                //                 { cell.length !== (i + 1) ? <hr/> : "" }
                //             </Fragment>
                //         ))
                //     }
                // </div>
                <Fragment>
                    {
                        cell ?
                            <div className="row" style={{ height: "auto", maxHeight: "300px", overflow: "auto" }}>
                                <div className="col-9 d-flex flex-column">
                                    {
                                        cell.map((v, i) => (
                                            <Fragment key={i}>
                                                <Link to="#" className="btn btn-bg-light btn-active-icon-gray-900 btn-active-text-gray-900 me-2 mb-2">
                                                    - {
                                                        v?.image ?
                                                            <div className="symbol symbol-50px me-2">
                                                                <img src={v?.image} alt="" className="h-75" />
                                                            </div>
                                                        : ""
                                                    }
                                                    {Object.values(Object.fromEntries(Object.entries(v).filter(([key]) => key !== "image" && key !== "quantity"))).join(" ~ ")} {row.price.currency}<br/>
                                                </Link>
                                            </Fragment>
                                        ))
                                    }
                                </div>
                                <div className="col-3 d-flex flex-column justify-content-start">
                                    <ModalEditInformations onSubmit={handleEditInformations} row={row} rowIndex={(page - 1) * sizePerPage + rowIndex} drop_list={"extension_drop_list_other"} column="variants" />
                                </div>
                            </div>
                        : ""
                    }
                </Fragment>
            ),
        },
        {
            dataField: "price",
            text: t("Informations"),
            sort: true,
            editable: false,
            style: {
                minWidth: "300px",
                maxWidth: "300px",
            },
            formatter: (cell, row, rowIndex) => (
                <Fragment>
                    <div className="row">
                        <div className="col-9 d-flex flex-column">
                            <h6>Product SKU:</h6><span className="ms-6">{row.product_sku}</span><hr/>
                            <h6>Price:</h6><span className="ms-6">{row.price.value} {row.price.currency}</span><hr />
                            <h6>Weight:</h6><span className="ms-6">{row.weight.value} {row.weight.type}</span><hr />
                            <h6>Dimensions:</h6>
                            <span className="ms-6">Length: {row.dimensions.length} {row.dimensions.unit}</span><br />
                            <span className="ms-6">Width: {row.dimensions.width} {row.dimensions.unit}</span><br />
                            <span className="ms-6">Height: {row.dimensions.height} {row.dimensions.unit}</span>
                        </div>
                        <div className="col-3 d-flex flex-column justify-content-center">
                            <ModalEditInformations onSubmit={handleEditInformations} row={row} column="price" />
                        </div>
                    </div>
                </Fragment>
            ),
        },
        {
            dataField: "category",
            text: t("Category"),
            sort: true,
            editable: false,
            style: {
                minWidth: "300px",
                maxWidth: "700px",
            },
            formatExtraData: { categoryVersion, categories, isCategoryInviteOnly },
            formatter: (cell, row, rowIndex, formatExtraData) => (
                <Fragment>
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <TreeSelect
                                showSearch
                                style={{ width: "100%" }}
                                treeNodeFilterProp="label"
                                dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                                className="h-100"
                                placeholder="Please select"
                                onChange={(cate) => {
                                    setList((prev) => {
                                        prev = prev.map((item) => {
                                            if (item.product_id === row.product_id) {
                                                return { ...item, category: cate };
                                            }
                                            return item;
                                        });
                                        return prev;
                                    });
                                }}
                                treeData={categories}
                                value={cell}
                            />
                        </div>
                        {
                            isCategoryInviteOnly?.[row?.product_id] ?
                                <div className="col-md-12">
                                    <span className="text-danger">{t("This is a restricted category and you do not have permission to use it. Please contact administrator")}</span>
                                </div>
                            : ""
                        }
                        <div className="col-md-9 mt-4">
                            <SelectBox
                                options={[
                                    { value: "v1", label: "v1" },
                                    { value: "v2", label: "v2" },
                                ]}
                                className="h-100"
                                name="category_version"
                                value={categoryVersion || "v2"}
                                onChange={(data) => {
                                    setCategoryVersion(data?.value);
                                }}
                            />
                        </div>
                        <div className="col-md-3 mt-4">
                            <button
                                className="btn btn-info"
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={t("Recommend Category")}
                                onClick={() => onClickGetRecommendCategories(row, formatExtraData)}
                            >
                                <i className="fa fa-lightbulb" style={{ fontSize: "20px" }}></i>
                            </button>
                        </div>
                    </div>
                </Fragment>
            ),
        },
        {
            dataField: "descriptions",
            text: t("Descriptions"),
            sort: true,
            editable: false,
            style: {
                minWidth: "300px",
                maxWidth: "700px",
            },
            formatter: (cell, row, rowIndex) => (
                <Fragment>
                    <div className="d-flex gap-4">
                        <div style={{ height: "auto", maxHeight: "300px", overflow: "auto" }} dangerouslySetInnerHTML={{ __html: cell }} />
                        <ModalEditDescriptions onSubmit={handleEditDescriptions} product_id={row.product_id} descriptions={cell} title={row.title} images={row.images} />
                    </div>
                </Fragment>
            ),
        },
        {
            dataField: "note",
            text: t("Note"),
            sort: true,
            formatter: (cell, row, rowIndex) => <Fragment>{cell}</Fragment>,
        },
        {
            dataField: "-",
            text: t("Actions"),
            editable: false,
            formatter: (cell, row, rowIndex) => (
                <>
                    <ModalAddImages onSubmit={handleAddImages} product_id={row.product_id} />
                    <button
                        className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Delete")}
                        onClick={() => deleteProduct(row.product_id)}
                    >
                        <i className="ki-outline ki-trash fs-2"></i>
                    </button>
                </>
            ),
        },
    ];

    const onSortEnd = (oldIndex, newIndex, itemIndex) => {
        setList((prev) => {
            prev[itemIndex].images = arrayMove(prev[itemIndex]?.images || [], oldIndex, newIndex);
            return [...prev];
        });
    };

    const removeImageProduct = (productId, imageRemove) => {
        setList((prev) => {
            prev = prev.map((product) => {
                if (product.product_id === productId) {
                    const images = (product?.images || []).filter((_image, key) => key !== imageRemove);
                    return { ...product, images };
                }
                return { ...product };
            })

            return [...prev];
        });
    };

    const deleteProduct = (product_id) => {
        setList((prev) => [...prev?.filter((v, i) => v.product_id !== product_id)]);
    };

    const deleteProducts = () => {
        setList((prev) => [...prev?.filter((v) => !products_selected.includes(v.product_id))]);
        setProductsSelected([]);
    };

    const removeSelect = (arr, value) => {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    };

    const onSelect = (row, isSelect) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp.push(row.product_id);
        } else {
            products_selected_tmp = removeSelect(products_selected_tmp, row.product_id);
        }
        var new_arr = JSON.stringify(products_selected_tmp);
        setProductsSelected(JSON.parse(new_arr));
    };

    const onSelectAll = (isSelect, rows) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp = rows.map(row => row.product_id);
        } else {
            products_selected_tmp = [];
        }
        setProductsSelected(products_selected_tmp);
    };

    const selectRow = {
        mode: "checkbox",
        clickToSelect: false,
        selected: products_selected,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
            <div className="d-flex">
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) {
                            input.indeterminate = indeterminate;
                            input.checked = checked;
                        }
                    }}
                    onChange={onChange}
                />
                <span style={{ marginLeft: '8px' }}>({products_selected.length})</span>
            </div>
        ),
    };

    const groupButton = () => {
        return (
            <div className="mb-5">
                {
                    expired_at - Date.now() >= 0 ?
                        <Fragment>
                            <ModalChangeText onSubmit={handleChangeText} />
                            <button onClick={() => { onClickChangeTitleByAI() }} className="btn btn-info btn-sm me-1" disabled={products_selected.length <= 0} >
                                <img src={require("components/assets/media/custom/stars-ai-white.svg").default} style={{ "marginTop": "-3px", "marginRight": "5px" }} alt="" />
                                {t("AI Title Optimization")}
                            </button>
                            <ModalTemplate onSubmit={uploadProduct} />
                            <button onClick={onClickExport} className="btn btn-success btn-sm me-1" disabled={products_selected.length <= 0}><i className="ki-outline ki-exit-down"></i>{t("Export")}</button>
                            <CSVLink className="d-none" filename={"other_" + formatterCreateAt((new Date()).getTime(), "dmy") + ".csv"} data={products_selected_export}>
                                <span ref={btnRef} />
                            </CSVLink>
                            {
                                _id === "67907ed4b2e597ee68eaf967" || parentId === "67907ed4b2e597ee68eaf967" ?
                                    <ModalExportFileTemplate onSubmit={onClickExportFileTemplate} row={products_selected} />
                                : ""
                            }
                            <button onClick={() => { onClickGetAllRecommendCategories() }} type="button" className="btn btn-info btn-sm me-1" disabled={products_selected.length <= 0}>
                                <i className="fa fa-lightbulb"></i> {t("Recommend Category")}
                            </button>
                        </Fragment>
                        : ""
                }
                <button onClick={deleteProducts} type="button" className="btn btn-danger btn-sm me-1" disabled={products_selected.length <= 0}>
                    {t("Delete Products")}
                </button>
                <ModalEditInformations onSubmit={handleEditInformations} place="groupbutton" row={products_selected} column="all" />
            </div>
        );
    };

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
        } else {
            setPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    const handleChangeText = (data) => {
        setList((prev) => {
            prev = prev.map((item) => {
                if (!products_selected.includes(item.product_id)) return item;
                let title = item?.title;
                if (data?.textNew && data?.textOld) {
                    title = title?.replace(new RegExp(data?.textOld, "gi"), data?.textNew || "");
                }

                if (data?.textStart) title = `${data?.textStart} ${title}`;
                if (data?.textEnd) title = `${title} ${data?.textEnd}`;

                return { ...item, title };
            });
            return prev;
        });
    };

    const handleAddImages = (product_id, data) => {
        setList((prev) => {
            prev = prev.map((item, i) => {
                if (item.product_id !== product_id) return item;
                let images = item?.images;
                if (data.length > 0) {
                    images = [...images, ...data];
                }

                return { ...item, images };
            });
            return prev;
        });
    };

    const handleEditDescriptions = (product_id, data) => {
        setList((prev) => {
            prev = prev.map((item, i) => {
                if (item.product_id !== product_id) return item;

                return { ...item, descriptions: data };
            });
            return prev;
        });
    };

    const handleEditInformations = (data) => {
        setList((prev) => {
            prev = prev.map((item, i) => {
                if (!data.product_id.includes(item.product_id)) return item;

                if (data.variants_selected.length > 0) {
                    data.variants_selected = data.variants_selected.map((v, i) => JSON.stringify(v));
                }
                var variants_split_tmp = data.variants_split.length > 0 ? data.variants_split : item.variants_split;
                var variants_split = variants_split_tmp.map((v_variant, i_variant) => {
                    if (data.variants_selected.length > 0) {
                        if (!data.variants_selected.includes(JSON.stringify(v_variant))) {
                            return { ...v_variant };
                        }
                    }

                    var price = v_variant.price;
                    if (data.variants.exchange_type === "rate") {
                        price = v_variant.price * data.variants.exchange_rate;
                    }
                    if (data.variants.exchange_type === "percent") {
                        price = parseFloat(v_variant.price) + parseFloat(v_variant.price * data.variants.exchange_rate / 100);
                    }
                    if (data.variants.exchange_type === "plus") {
                        price = parseFloat(v_variant.price) + parseFloat(data.variants.exchange_rate);
                    }
                    if (data.variants.exchange_type === "fix") {
                        price = parseFloat(data.variants.exchange_rate);
                    }
                    if (data.variants.exchange_type === "custom") {
                        try {
                            price = evaluate(data.variants.exchange_rate.replace(/{price}/g, parseFloat(v_variant.price)));
                        } catch (error) {
                            price = v_variant.price;
                        }
                    }

                    var quantity = v_variant?.quantity || 100;
                    if (data.variants.change_type_quantity === "rate") {
                        quantity = (v_variant?.quantity || 100) * data.variants.change_rate_quantity;
                    }
                    if (data.variants.change_type_quantity === "plus") {
                        quantity = parseFloat(v_variant?.quantity || 100) + parseFloat(data.variants.change_rate_quantity);
                    }
                    if (data.variants.change_type_quantity === "fix") {
                        quantity = parseFloat(data.variants.change_rate_quantity);
                    }

                    return { ...v_variant, price: scaleNumber({ number: price }), quantity: scaleNumber({ number: quantity, fix: 0 }) };
                });

                var price = item.price.value;
                if (data.price.exchange_type === "rate") {
                    price = item.price.value * data.price.exchange_rate;
                }
                if (data.price.exchange_type === "percent") {
                    price = parseFloat(item.price.value) + parseFloat(item.price.value * data.price.exchange_rate / 100);
                }
                if (data.price.exchange_type === "plus") {
                    price = parseFloat(item.price.value) + parseFloat(data.price.exchange_rate);
                }
                if (data.price.exchange_type === "fix") {
                    price = parseFloat(data.price.exchange_rate);
                }
                if (data.price.exchange_type === "custom") {
                    try {
                        price = evaluate(data.price.exchange_rate.replace(/{price}/g, parseFloat(item.price.value)));
                    } catch (error) {
                        price = item.price.value;
                    }
                }

                return { ...item, price: { ...item.price, value: scaleNumber({ number: price }) }, weight: data.weight, dimensions: data.dimensions, variants_split };
            });
            return prev;
        });
        setForceRender((prev) => !prev);
    };

    const uploadProduct = ({ templateId, categoryId, otherImage, removePrdImport, numberImage, categoryVersion, categories, currency, attribute_products }) => {
        var extension_settings = localStorage.getItem("extension_settings") ? JSON.parse(localStorage.getItem("extension_settings")) : {};
        createProductsByTemplate({
            templateId,
            categoryId,
            categoryVersion,
            categories,
            type: "drop",
            attribute_products,
            currency,
            data: list.reduce((result, item) => {
                if (products_selected.includes(item.product_id)) {
                    const itemAdd = { ...item, main_images: item.images.slice(0, numberImage), product_sku: item?.product_sku || item.product_id, };
                    if (otherImage?.length) itemAdd.main_images = [...(itemAdd.main_images || []), ...otherImage];
                    result.push(itemAdd);
                }
                return result;
            }, []),
            setIsLoadingImport,
            filterProduct: +extension_settings?.general?.filter_duplicate_products || 0
        }).then((r) => {
            if (removePrdImport && r) {
                setList((prev) => prev.filter((item) => !products_selected.includes(item.product_id)));
                setProductsSelected([]);
            }
        });
    };

    const handleTableSaveCell = (oldValue, newValue, row, column) => {
        row[column.dataField] = newValue;
        setList((prev) => {
            const data = prev.map((product) => {
                if (product.product_id === row.product_id) {
                    product[column.dataField] = newValue;
                }
                return product;
            });
            return [...data];
        });
    };

    const onClickChangeTitleByAI = () => {
        var arr_product = [];
        products_selected.forEach((v, i) => {
            var product_find = list.find((v2, i2) => v2?.product_id === v);
            if (product_find) {
                arr_product.push({ [product_find?.product_id]: product_find?.title });
            }
        });
        changeTitleByAI(arr_product, setList);
    };

    const onClickGetAllRecommendCategories = async () => {
        setIsLoadingRecommend(true);
        for (const product_id of products_selected) {
            const product_find = list.find((v, i) => v?.product_id === product_id);
            await getRecommendCategories(
                () => {},
                categoryVersion || "v2",
                product_find?.title,
                product_find?.images?.[0] || ""
            ).then((data) => {
                // setCategories((data || []).map((c) => ({ value: c.id, label: c.local_name, children: c.children })));
                if (data?.[data?.length - 1]?.id) {
                    setList((prev) => {
                        prev = prev.map((item) => {
                            if (item.product_id === product_find.product_id) {
                                return { ...item, category: data?.[data?.length - 1]?.id };
                            }
                            return item;
                        });
                        return prev;
                    });
                    setIsCategoryInviteOnly((prev) => {
                        prev = {
                            ...prev,
                            [product_find.product_id]: data?.[data?.length - 1]?.permission_statuses.includes("INVITE_ONLY") ? true : false
                        };
                        return prev;
                    });
                }
            });
        }
        setIsLoadingRecommend(false);
    };

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "20",
            value: 20,
        },
        {
            text: "30",
            value: 30,
        },
        {
            text: "40",
            value: 40,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "All",
            value: list.length || 10,
        },
    ];

    return (
        <Fragment>
            <Loading isLoading={isLoading || isLoadingExport || isLoadingImport || isLoadingRecommend} />
            <ReactTable
                key={forceRender}
                keyField="product_id"
                columns={columns}
                data={list}
                groupButton={groupButton}
                handleTableChange={handleTableChange}
                page={page}
                sizePerPage={sizePerPage}
                totalSize={list.length}
                alClassName="table-layout-inherit"
                remote={{ search: false, pagination: false, sort: false }}
                isSelectRow={true}
                selectRow={selectRow}
                isCellEdit={true}
                handleBeforeSaveCell={handleTableSaveCell}
                sizePerPageList={sizePerPageList}
                pagination={paginationFactory({
                    page,
                    sizePerPage,
                    totalSize: list.length,
                    sizePerPageList,
                    onPageChange: (page, sizePerPage) => {
                        setPage(page);
                        setSizePerPage(sizePerPage);
                    },
                    onSizePerPageChange: (sizePerPage, page) => {
                        setSizePerPage(sizePerPage);
                        setPage(page);
                    }
                })}
            />
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    user: state.user,
    ai: state.ai
});
const mapDispatchToProps = { createProductsByTemplate, countString, formatterCreateAt, scaleNumber, changeTitleByAI, getCategories, getRecommendCategories };

export default connect(mapStateToProps, mapDispatchToProps)(Main);
